var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h5',[_vm._v("Número de productos vendidos por unidad de negocio")]),_c('v-card',{staticClass:"elevation-0",staticStyle:{"height":"100%"},attrs:{"loading":_vm.loading}},[_c('Pie',{attrs:{"id":"recaudo-chart","options":_vm.chartOptions,"data":_vm.chartData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }